import { Experiences } from '@/src/experiences'

export default Experiences.Rewards.Screens.PointsTransferInterstitial.screen
